import React, { useState, useRef, useEffect } from 'react';

type OptionButtonProps = {
  buttons: { label: string; onClick: (e: React.MouseEvent) => void }[]; // Accept the event in onClick
  className?: string;
};

const OptionButton: React.FC<OptionButtonProps> = ({ buttons, className }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [expandUpwards, setExpandUpwards] = useState(false);
  const buttonRef = useRef<HTMLDivElement>(null);

  const toggleOption = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent event propagation to parent
    setIsOpen((prev) => !prev);
  };

  useEffect(() => {
    if (buttonRef.current) {
      const { bottom } = buttonRef.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      setExpandUpwards(bottom > windowHeight / 2);
    }
  }, [isOpen]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (buttonRef.current && !buttonRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className={className}>
    <div className={`relative`} ref={buttonRef}>
      <button
        className="px-3 pb-3 rounded hover:bg-slate-200 focus:outline-none m-2"
        onClick={toggleOption}

      >
        <span className="text-xl text-gray-600">...</span>
      </button>

      {isOpen && (
        <div
          className={`absolute ${
            expandUpwards ? 'bottom-full mb-2' : 'top-full mt-2'
          } right-0 flex flex-col space-y-2 bg-white shadow-lg rounded-md p-2 z-50`}
        >
          {buttons.map((button, index) => (
            <button
              key={index}
              className="px-4 py-2 text-left text-slate-700 hover:bg-slate-100 rounded-md focus:outline-none"
              onClick={(e) => {
                e.stopPropagation();
                toggleOption(e);
                button.onClick(e);
              }}
            >
              {button.label}
            </button>
          ))}
        </div>
      )}
    </div>
    </div>
  );
};

export default OptionButton;
